<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <div class="title">
        重命名
      </div>
      <div class="body">
        <textarea v-model="newName"></textarea>
        <div class="num">{{wordNum}} / 40</div>
      </div>
      <div class="btn-container">
        <div @click="submit" class="btn green">提交</div>
        <div @click="cancel" class="btn">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'rename',
  data() {
    return {
      show: true,
      content: {
        id: 0,
        type: 0,
        msg: ''
      },
      maxlength: 60,
      r: null,
      disabled: false,
      startEmpty: false,
      newName: '',
      saveNewName: '',
      wordNum: 0
    }
  },
  watch: {
    content: {
      deep: true,
      handler: function(n, o) {
        if (n.msg) {
          this.disabled = false
        } else {
          if (this.startEmpty) {
            this.disabled = true
          }
        }
      }
    },
    newName() {
      this.watchTitle();
    }
  },
  methods: {
    submit() {
      let content = {}
      content.name = this.newName
      content.idstring = this.content.idstring
      this.r(content)
      this.close()
    },
    watchTitle() {
      let str = this.newName;
      this.getLength(str);
    },
    getLength(str) {
      var n = null;
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) >= 0 && str.charCodeAt(i) <= 256) {
          n += 0.5;
        } else {
          n += 1;
        }
      }

      if (n <= 40) {
        this.saveNewName = this.newName;
      } else {
        this.newName = this.saveNewName;
      }

      this.wordNum = Math.floor(n);
    },
    open(content, r) {
      window.document.body.style.overflowY = 'hidden'
      this.content = content
      this.newName = content.title
      if (!this.content.msg) {
        this.startEmpty = true
        this.disabled = true
      }
      this.r = r
      this.show = true
    },
    close() {
      window.document.body.style.overflowY = 'auto'
      this.show = false
    },
    async confirm() {
      if (this.disabled) return
      if (!this.content.msg) {
        let c = await this.$confirm('警示内容为空，将删除警示')
        if (!c) return
      }

      const info = {
        subject_id: this.content.id,
        subject_type: this.content.type,
        info: this.content.msg
      }

      common.myFetch(apis.warn_add, info)
      .then((res) => {
        if (res) {
          this.$toast(res)
          this.r(true)
        }

        this.close()
      })
    },
    cancel() {
      this.r(null)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .wrapper {
    height: 258px;
    width: 700px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;

    .title {
      font-size: 24px;
      line-height: 33px;
      color: #050F0F;
      font-weight: bold;
      margin-bottom: 17px;
    }

    .body {
      position: relative;
      width: 100%;
      height: 100px;
      padding: 14px 20px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #D3D3D3;
      box-sizing: border-box;
      overflow: hidden;

      textarea {
        width: 100%;
        height: 100%;
        resize: none;
        font-size: 16px;
        line-height: 24px;
        color: #3D3D3D;

        &::-webkit-scrollbar {
          width: 4px;
          height: 0;
        }
        &::-webkit-scrollbar-thumb {
          // background: rgba(5, 15, 15, 0.6);
          background: #B9C3C3;
          border-radius: 4px;
        }
      }

      .num {
        position: absolute;
        bottom: 12px;
        right: 16px;
        font-size: 16px;
        color: #CCC;
      }
    }

    .btn-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
    }

    .close {
      cursor: pointer;
    }
    .btn {
      background-color: @dateColor;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      color: #fff;
      font-size: 14px;
      // box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }
    .disabled {
      cursor: not-allowed;
      color: #fff !important;
      background-color: @dateColor !important;
    }
  }
</style>
